@import '../../../common/facets/facet-common.pcss';
@import '../../../common/facets/facet-search/facet-search.pcss';

[part~='active-parent'] {
  @apply pl-9;
}

[part~='parents'] [part~='values'] {
  @apply pl-9;
}

[part~='all-categories-button'],
[part~='parent-button'] {
  @apply relative flex w-full items-center py-2.5 pl-7 pr-2 text-left;
}

[part~='back-arrow'] {
  @apply absolute left-1 h-5 w-5;
}
